import React from 'react';

import './Footer.css';

const Footer = () => {
    return (
        <div className="container-fluid footer-area col-sm-12">
            <h5>	&copy; CopyRight All Reserved Hero Team</h5>
        </div>
    );
};

export default Footer;